<template>
  <div class="navbar-container d-flex content align-items-center" :class="environmentClass">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <bookmarks />
    </div>

    <!-- Right Col -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- <locale /> -->
      <dark-Toggler class="d-none d-lg-block" />
      <environment-badge />
      <search-bar />
      <notification-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import DarkToggler from './components/DarkToggler.vue'
import SearchBar from './components/SearchBar.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import EnvironmentBadge from '@/layouts/components/navbar/components/EnvironmentBadge.vue'
import { 
  detectEnvironment, 
  getEnvironmentNavbarClasses 
} from '@/util/EnvironmentUtils'

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    DarkToggler,
    SearchBar,
    NotificationDropdown,
    UserDropdown,
    EnvironmentBadge,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    environment() {
      return detectEnvironment()
    },
    environmentClass() {
      return getEnvironmentNavbarClasses(this.environment)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar-container {
  transition: background-color 0.3s ease;
  
  &.navbar-env-dev {
    background-color: rgba(34, 197, 94, 0.08) !important;
    border-bottom: 2px solid rgba(34, 197, 94, 0.2);
  }
  
  &.navbar-env-staging {
    background-color: rgba(251, 191, 36, 0.08) !important;
    border-bottom: 2px solid rgba(251, 191, 36, 0.2);
  }
  
  &.navbar-env-prod {
    // Produção não precisa de cor especial
  }
}

// Ajustes para tema escuro
.d-theme-dark-light-bg .navbar-container {
  &.navbar-env-dev {
    background-color: rgba(34, 197, 94, 0.12) !important;
    border-bottom-color: rgba(34, 197, 94, 0.3);
  }
  
  &.navbar-env-staging {
    background-color: rgba(251, 191, 36, 0.12) !important;
    border-bottom-color: rgba(251, 191, 36, 0.3);
  }
}
</style>
